import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import HeroSection from './components/sections/HeroSection';
import AboutSection from './components/sections/AboutSection';
import ProjectsSection from './components/sections/ProjectsSection';
import CareersSection from './components/sections/CareersSection';
import ContactSection from './components/sections/ContactSection';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-1">
        <Header data-id="element-2" />
        <main className="flex-grow" data-id="element-3">
          <HeroSection data-id="element-4" />
          <AboutSection data-id="element-5" />
          <ProjectsSection data-id="element-6" />
          <CareersSection data-id="element-7" />
          <ContactSection data-id="element-8" />
        </main>
        <Footer data-id="element-9" />
      </div>
    </BrowserRouter>;
}